/* The shop's closed days come from snippets/shipping-calendar, rendered in the
   head. Weekends-only is the fallback, so a missing snippet degrades to the old
   behaviour rather than breaking the badge. */
function shippingCalendar() {
  return (
    window.TidalShipping || {
      isClosed: function (d) {
        var day = d.getDay();
        return day === 0 || day === 6;
      },
      addBusinessDays: function (start, n) {
        var out = new Date(start);
        var added = 0;
        while (added < n) {
          out.setDate(out.getDate() + 1);
          if (!this.isClosed(out)) added++;
        }
        return out;
      },
    }
  );
}

if (!customElements.get('delivery-date')) {
  customElements.define(
    'delivery-date',
    class DeliveryDate extends HTMLElement {
      connectedCallback() {
        const type = this.dataset.type;
        const days = parseInt(this.dataset.days, 10);
        const format = this.dataset.format || 'product';
        const start = this.getStartDate();

        let targetDate;

        if (type === 'rush') {
          targetDate = this.addBusinessDays(start, days);
          this.textContent = this.formatDate(targetDate, format);
          const span = document.createElement('span');
          span.className = 'delivery-date__business-days';
          span.textContent = ` (${days} Business Days)`;
          this.appendChild(span);
        } else {
          targetDate = this.addCalendarDays(start, days);
          this.textContent = this.formatDate(targetDate, format);
        }
      }

      getStartDate() {
        const estStr = new Date().toLocaleString('en-US', {
          timeZone: 'America/New_York',
        });
        const est = new Date(estStr);

        // Orders placed after the daily cut-off are produced the next business day.
        let cutoffHour = parseInt(this.dataset.cutoffHour, 10);
        if (Number.isNaN(cutoffHour)) cutoffHour = 15;

        if (est.getHours() >= cutoffHour) {
          est.setDate(est.getDate() + 1);
        }
        est.setHours(0, 0, 0, 0);
        return est;
      }

      // Business days skip weekends AND the shop's closed dates. Counting a
      // holiday as a working day promised every "(N Business Days)" date inside
      // a holiday week one day early for each holiday it spanned.
      addBusinessDays(start, count) {
        return shippingCalendar().addBusinessDays(start, count);
      }

      addCalendarDays(start, count) {
        return new Date(start.getTime() + count * 86400000);
      }

      formatDate(date, format) {
        const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        const months = [
          'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
          'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
        ];
        const wd = days[date.getDay()];
        const mo = months[date.getMonth()];
        const dy = date.getDate();

        if (format === 'collection') {
          return `${wd}, ${mo} ${dy}`;
        }
        return `${wd} ${mo} ${String(dy).padStart(2, '0')}`;
      }
    }
  );
}
